var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basket-wrapper"},[_c('div',{staticClass:"basket",class:{'basket-empty': _vm.isBasketEmpty()}},[_c('BasketHeader'),_c('BasketBody'),(_vm.isBasketEmpty())?_c('BasketListFooter'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }